const ITEMS = [
  "Study Abroad Consulting",
  "Study Visa Guidance",
  "Education Loans",
  "Accommodation Support",
  "UK",
  "USA",
  "Canada",
  "Australia",
  "Germany",
  "New Zealand",
];

const Row = ({ hidden }) => (
  <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={`${item}-${i}`} className="flex items-center">
        <span className="whitespace-nowrap px-7 font-display text-xl font-light italic text-frost/75 sm:text-2xl">
          {item}
        </span>
        <span className="inline-block h-1.5 w-1.5 rotate-45 bg-mint/80" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <section data-testid="marquee-strip" className="overflow-hidden border-y border-white/10 py-6 lg:py-7">
      <div className="marquee-track">
        <Row hidden={false} />
        <Row hidden={true} />
      </div>
    </section>
  );
}
